import { useState, useEffect, useCallback } from 'react'
import type { FulfillmentTaskListItem, WineSalesMonthly } from '../types/fulfillment'
import { getPartnerTasks } from '../services/fulfillmentService'
import { useAuth } from '../contexts/AuthContext'

export function usePartnerTasks() {
  const { user, claims } = useAuth()
  const [tasks, setTasks] = useState<FulfillmentTaskListItem[]>([])
  const [wineSalesMonthly, setWineSalesMonthly] = useState<WineSalesMonthly | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchTasks = useCallback(async () => {
    if (!user || claims?.role !== 'partner') return
    setLoading(true)
    setError(null)
    try {
      const result = await getPartnerTasks()
      setTasks(result.tasks)
      setWineSalesMonthly(result.wineSalesMonthly)
    } catch (err: any) {
      setError(err?.message ?? 'Erro ao carregar pedidos.')
    } finally {
      setLoading(false)
    }
  }, [user, claims])

  useEffect(() => {
    fetchTasks()
  }, [fetchTasks])

  return { tasks, wineSalesMonthly, loading, error, refetch: fetchTasks }
}
